import { CompanyShape } from "~shapes/company"
import { TableResponseShape } from "~shapes/api-table"

export interface PostMessageShape {
  id?: string
  code: string
  name: string
  description: string
  cover: string
  status: string
  company: string
  publishedAt: string
}

export interface MessagesListShape extends TableResponseShape {
  _embedded: {
    posts: MessageShape[]
  }
}

export interface MessageShape {
  id: string
  code: string
  communicationLevelPinned: boolean
  companyLevelPinned: boolean
  name: string
  description: string
  cover: string
  status: MessageStatus
  createdAt: string
  updatedAt: string
  publishedAt: string
  company: CompanyShape
}

export enum MessageStatus {
  ACTIVE = "Active",
  INACTIVE = "Inactive",
}

export enum MessagePinLevel {
  COMPANY_LEVEL = "Company level",
  COMMUNICATION_LEVEL = "Communication level",
}
